import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { PageNotFoundComponent } from "./pages/page-not-found/page-not-found.component";
import { SelectingHoldingComponent } from "./pages/main/selecting-holding/selecting-holding.component";
import { AuthGuardService } from "./services/guards/auth-guard.service";
import { MainLayoutStudentComponent } from "./core/main-layout-student/main-layout-student.component";
import { StudentCourseComponent } from "./pages/student/student-course/student-course.component";
import { RegisterCoursesComponent } from "./pages/student/student-course/register-courses/register-courses.component";
import { StudenteducationalbackgroundComponent } from "./pages/student/student-course/studenteducationalbackground/studenteducationalbackground.component";
import { StudentPlacementComponent } from "./pages/student/student-placement/student-placement.component";
import { PlacementReservationsComponent } from "./pages/student/student-placement/placement-reservations/placement-reservations.component";
import { StudentDocumentsComponent } from "./pages/student/student-discount/student-documents/student-documents.component";
import { StudentDiscountComponent } from "./pages/student/student-discount/student-discount.component";
import { StudentInvoiceComponent } from "./pages/student/student-invoice/student-invoice.component";
import { InvoicesComponent } from "./pages/student/student-invoice/invoices/invoices.component";
import { RegistrationCourseComponent } from "./pages/student/student-course/registration-course/registration-course.component";
import { SubsidiaryDashboardContractComponent } from "./pages/subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-contract.component";
import { StudentPrivateClassComponent } from "./pages/student/student-private-class/student-private-class.component";
import { RequestPrivateClassListComponent } from "./pages/student/student-private-class/request-private-class-list/request-private-class-list.component";
import { StudentProfileEditComponent } from "./pages/student/student-profile-edit/student-profile-edit.component";

const routes: Routes = [
  {
    path: "hbr",
    component: SelectingHoldingComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: "subsidiaryContracts",

    component: SubsidiaryDashboardContractComponent,
    canActivate: [AuthGuardService]
  },

  {
    path: "student",
    component: MainLayoutStudentComponent,
    canActivate: [AuthGuardService],
    children: [
      // Course
      {
        path: "course",
        component: StudentCourseComponent,
        children: [
          {
            path: "registerCourses",
            component: RegisterCoursesComponent,
            data: {
              breadcrumb: "registeredCourses",
              showCompanyButton: true
            }
          },
          {
            path: "registrationCourse",
            component: RegistrationCourseComponent,
            data: {
              breadcrumb: "courseRegistration",
              showCompanyButton: true
            }
          },
          {
            path: "studentEducationalBackground",
            component: StudenteducationalbackgroundComponent,
            data: {
              breadcrumb: "studentEducationalBackground",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "course",
          showCompanyButton: true,
          hasGuide: false
        }
      },
      // Placement
      {
        path: "placement",
        component: StudentPlacementComponent,
        children: [
          {
            path: "reservation",
            component: PlacementReservationsComponent,
            data: {
              breadcrumb: "placementReservation",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "placement",
          showCompanyButton: true,
          hasGuide: false
        }
      },
      // Discount
      {
        path: "discount",
        component: StudentDiscountComponent,
        children: [
          {
            path: "studentDocuments",
            component: StudentDocumentsComponent,
            data: {
              breadcrumb: "submitteDocuments",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "discount",
          showCompanyButton: true,
          hasGuide: false
        }
      },
      //private class
      {
        path: "requests",
        component: StudentPrivateClassComponent,
        children: [
          {
            path: "privateClass",
            component: RequestPrivateClassListComponent,
            data: {
              breadcrumb: "requestPrivateClass",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "requests",
          showCompanyButton: true,
          hasGuide: false
        }
      },
      // Invoice
      {
        path: "invoice",
        component: StudentInvoiceComponent,
        children: [
          {
            path: "invoices",
            component: InvoicesComponent,
            data: {
              breadcrumb: "invoices",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "invoice",
          showCompanyButton: true,
          hasGuide: false
        }
      },
      {
        path: "profile",
        component: StudentProfileEditComponent,
        data: {
          breadcrumb: "profile",
          showCompanyButton: true,
          hasGuide: false
        }
      },


      //{ path: "dashboard", component: DashboardComponent }
    ]
  },
  { path: "**", component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
